(function VirtualEventsView($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/VirtualEvents/view/', function onload() {
			$('.closed-caption-link').click(function toggleVideo(e) {
				e.preventDefault();

				$('.closed-caption').removeClass('hidden');
			});
		});
	});
}(jQuery, window.Adzuki || {}));